import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import './SortBy.css';

import { SortOrders } from 'src/Common/constants';
import { SalesContext } from 'src/Context/SalesContext';
import { tagOnFilterSortBy } from 'src/Tagging/SalesTagging';

import {
  UpDownArrow,
  ArrowIcon
} from 'src/Components/Common/Svg/index';

import {
  getPageArray
} from 'src/Utility/utility';

class SortBy extends React.Component {
  static contextType = SalesContext;
  state = {
    selectedSortOption: 'Price - Lowest to highest ',
    showOptions: false
  }

  showOptions() {
    this.setState(prevState => {
      return { showOptions: !prevState.showOptions }
    });
     this.setState({
      sortOrder: this.context.sortOrder
    })
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutsideSortMenu, true);
    if (this.context.sortOrder === SortOrders.ASC) {
      this.setState({ selectedSortOption: 'Price - Lowest to highest ' });
    } else {
      this.setState({ selectedSortOption: 'Price - Highest to lowest' });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutsideSortMenu, true);
  }

  handleClickOutsideSortMenu = event => {
    // eslint-disable-next-line react/no-find-dom-node
    const domNode = ReactDOM.findDOMNode(this);
    if (domNode && !domNode.contains(event.target))
      this.setState({ showOptions: false });
  }

  setSortOrder(order, optionValue) {
    this.context.setShowSpinner(true);
    this.context.setSortOrder(order);
    this.context.setSelectedPageNo(1);
    this.setState({
      sortOrder: order
    })

    tagOnFilterSortBy();

    // Get Provider Packages
    this.context.setPageNos(getPageArray([this.context.providerPackages]), () => this.props.determinePackages());
    this.context.setShowSpinner(false);

    this.setState({
      showOptions: false,
      selectedSortOption: optionValue
    })
  }

  render() {
    return (
      <div className="sort-by-wrapper" automationid="SalesLead_Div_SortByWrapper_0">
        <div className="sort-by-dropdown-wrapper" automationid="SalesLead_Div_SortByDropdownWrapper_0">
          <div className="sort-by-desktop-view" automationid="SalesLead_Div_SortByDesktopView_0">
            Sort by:
            <div className="selected-option-wrapper" onClick={() => this.showOptions()} automationid="SalesLead_Div_SortBySelectOptionWrapper_0">
              <div className="selected-option" automationid="SalesLead_Div_SortBySelectedOption_0">
                {
                  this.context.sortOrder === SortOrders.ASC ? 'Price - Lowest to highest' : 'Price - Highest to lowest'
                }
              </div>
              <div className="sort-by-arrow-icon" automationid={'SalesLead_Div_SortByArrowIcon_0'}>
                <ArrowIcon
                  direction={this.state.showOptions ? 'icon-chevron-up' : 'icon-chevron-down'}
                  automationidattr={'SortBy'}
                />
              </div>
            </div>
          </div>
          <div className="mobile-view" automationid="SalesLead_Div_SortByMobileView_0">
            <div className="selected-option-wrapper" onClick={() => this.showOptions()} automationid="SalesLead_Div_SortBySelectOptionWrapper_1">
              <div className="sort-by-text"><UpDownArrow/> <span style={{marginLeft: '10px'}}><b>Sort by</b></span></div>
              <div className="selected-option" automationid="SalesLead_Div_SortBySelectedOption_1">
                {
                  this.context.sortOrder === SortOrders.ASC ? 'Price - Lowest to highest' : 'Price - Highest to lowest'
                }
              </div>
              <div className="sort-by-arrow-icon" automationid={'SalesLead_Div_SortByArrowIconMobile_0'}>
                <ArrowIcon
                  direction={this.state.showOptions ? 'icon-chevron-up' : 'icon-chevron-down'}
                  automationidattr={'SortBy'}
                />
              </div>
            </div>
          </div>

          {
            this.state.showOptions ?
              <div className="sort-options-wrapper" automationid="SalesLead_Div_SortByOptionWrapper_0">
                <div className="sort-option"
                  onClick={() => this.setSortOrder(SortOrders.ASC, 'Price - Lowest to highest ', 'price')}
                  automationid="SalesLead_Div_SortByOptions_0">
                  <div className="fm-data" automationid="SalesLead_Div_SortByOptionLabel_0" >
                    <input type="radio"
                      value="Price - Lowest to highest "
                      name="popup_radio"
                      automationid="SalesLead_Input_SortByRadioButton_0"
                    />
                    <label 
                      className={
                        this.context.sortOrder === SortOrders.ASC ? 'checked' : 'uncheked'
                      } 
                      data-group="radio-0" 
                      automationid="SalesLead_Input_SortByRadioLabel_0" >
                    </label>
                  </div>
                  <div className="sort-option-name" automationid="SalesLead_Input_SortByOptionName_0">
                    <p automationid="SalesLead_Paragraph_OptionText_0">Price - Lowest to highest  </p>
                  </div>
                </div>

                <div className="sort-option"
                  onClick={() => this.setSortOrder(SortOrders.DESC, 'Price - Highest to lowest', 'price')}
                  automationid="SalesLead_Div_SortByOptions_1">
                  <div className="fm-data" automationid="SalesLead_Div_SortByOptionLabel_1">
                    <input type="radio" value="Price - Lowest to highest " name="popup_radio" automationid="SalesLead_Input_SortByRadioButton_1" />
                    <label 
                      className={
                        this.context.sortOrder === SortOrders.DESC ? 'checked' : 'uncheked'
                      } 
                      data-group="radio-0" 
                      automationid="SalesLead_Input_SortByRadioLabel_1">
                    </label>
                  </div>
                  <div className="sort-option-name" automationid="SalesLead_Input_SortByOptionName_1">
                    <p automationid="SalesLead_Paragraph_OptionText_1">Price - Highest to lowest </p>
                  </div>
                </div>

                {
                  this.context?.filters?.onPromotion ?
                    <div className="sort-option"
                      onClick={() => this.setSortOrder(SortOrders.DESC, 'On Promotion', 'onPromotion')}
                      automationid="SalesLead_Div_SortByOptions_2">
                      <div className="fm-data" automationid="SalesLead_Div_SortByOptionLabel_2">
                        <input type="radio" value="On Promotion" name="popup_radio" automationid="SalesLead_Input_SortByRadioButton_2" />
                        <label 
                          className={
                            this.state.selectedSortOption === 'On Promotion' ? 'checked' : 'uncheked'
                          } 
                          data-group="radio-0" 
                          automationid="SalesLead_Input_SortByRadioLabel_2">
                        </label>
                      </div>
                      <div className="sort-option-name" automationid="SalesLead_Input_SortByOptionName_2">
                        <p automationid="SalesLead_Paragraph_OptionText_2">On Promotion </p>
                      </div>
                    </div>
                    :
                    null
                }
              </div>
              :
              null
          }
        </div>
        <div className="count-desktop-view result-count"></div>
      </div>
    )
  }
}

SortBy.propTypes = {
  determinePackages: PropTypes.func
};

export default SortBy;